import "./scss/impressum.scss"

window.jQuery = require("jquery")
const $ = window.jQuery

import "popper.js"
import "bootstrap"
import "jquery-validation/dist/jquery.validate"

require("./scripts/slider")
// require("./scripts/smooth-scroll")
require("./scripts/form-validation")

$(document).ready(() => {

  const toggleShowMenu = () => {
    $("#container").toggleClass("show-menu")
  }
  $("#hamburger-menu-button").click(toggleShowMenu)

  $(".menu-mobile").click(toggleShowMenu);
  $(".blured-overlay").click(toggleShowMenu);

})